import { render, staticRenderFns } from "./SignIn-Agree.vue?vue&type=template&id=766a05b1&scoped=true&"
import script from "./SignIn-Agree.vue?vue&type=script&lang=js&"
export * from "./SignIn-Agree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a05b1",
  null
  
)

export default component.exports